var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeferTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2584_12592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2584_12592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 8.4001L7.5 6.4001L5.5 5.5001L7.5 4.6001L8.4 2.6001L9.325 4.6001L11.3 5.5001L9.325 6.4001L8.4 8.4001ZM14.9 11.4001L14.15 9.7501L12.5 9.0001L14.15 8.2501L14.9 6.6001L15.65 8.2501L17.3 9.0001L15.65 9.7501L14.9 11.4001ZM3.9 13.4001L3.15 11.7501L1.5 11.0001L3.15 10.2501L3.9 8.6001L4.65 10.2501L6.3 11.0001L4.65 11.7501L3.9 13.4001ZM4.375 20.1501L3.25 19.0501L10.4 11.8751L14.4 15.8751L21.45 7.9001L22.5 8.9251L14.425 18.1251L10.4 14.1251L4.375 20.1501Z",
    fill: "#0067D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeferTax);
export default __webpack_public_path__ + "static/media/defer_tax.22812f9216485b43637d6959b3822b79.svg";
export { ForwardRef as ReactComponent };